export const residentialOptions = [
    {
        label: 'Tenant',
        value: 'tenant'
    },
    {
        label: 'Owner occupier (with mortgage)',
        value: 'owner_with_mortgage'
    },
    {
        label: 'Owner occupier (no mortgage)',
        value: 'owner_no_mortgage'
    },
    {
        label: 'Living rent free (e.g. with parents)',
        value: 'rent_free'
    }
];

export const additionalNumberOfDependentsOptions = [
    { value: 0, title: '0' },
    { value: 1, title: '1' },
    { value: 2, title: '2' },
    { value: 3, title: '3' },
    { value: 4, title: '4' },
    { value: 5, title: '5' },
    { value: 6, title: '6 or more' }
];
